/**
 * Helpers for the contract activity panel — kept out of the component so the
 * wording and timing rules can be tested without rendering.
 */

export const MAX_COMMENT_LENGTH = 2000;

const ROLE_LABELS = {
  super_admin: 'Admin',
  procurement: 'Procurement',
  legal: 'Legal',
  management: 'HOD',
};

export const roleLabel = (role) => ROLE_LABELS[role] || '';

// Suppliers never see the thread; the server refuses them too.
export const canSeeActivity = (user) => Boolean(user?.role) && user.role !== 'supplier';

// The supplier page carries the thread for staff with no way into Contract
// Management, procurement above all. It needs the contract itself, populated.
export const showsContractComments = (user, supplier) =>
  canSeeActivity(user) && Boolean(supplier?.contract?._id);

/** "just now", "5 min ago", "3 h ago", then a date: "12 Oct 2026, 14:05". */
export const formatWhen = (at, now = Date.now()) => {
  const date = new Date(at);
  if (Number.isNaN(date.getTime())) return '';
  const seconds = Math.round((now - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)} h ago`;
  return date.toLocaleString('en-GB', {
    day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
};

/** The server's offer to delete, checked again against the clock the page has been open for. */
export const stillDeletable = (item, now = Date.now()) =>
  Boolean(item?.canDelete && item.deletableUntil && new Date(item.deletableUntil).getTime() > now);

/** What is wrong with a draft comment, or '' if it can be posted. */
export const commentError = (text) => {
  const trimmed = (text || '').trim();
  if (!trimmed) return 'Write something first';
  if (trimmed.length > MAX_COMMENT_LENGTH) return `Keep it to ${MAX_COMMENT_LENGTH} characters`;
  return '';
};
